import React from 'react';
import { AbsoluteFill } from 'remotion';

export default function HidePreMountTrack({
  children,
  isPreMounted
}: {
  children: React.ReactNode;
  isPreMounted: boolean;
}) {
  return <AbsoluteFill style={isPreMounted ? { width: '0', height: '0' } : {}}>{children}</AbsoluteFill>;
}
